export default __webpack_public_path__ + "static/media/card-icon.86b64738.svg";